import { cssVar, defineStyleConfig } from '@chakra-ui/react'

const $inputPadding = cssVar('number-input-input-padding')

export const inputTheme = defineStyleConfig({
  baseStyle: {
    field: {
      display: 'block',
      height: 'auto',
      paddingX: '8px',
      paddingY: '8px',
      [$inputPadding.variable]: '8px', // override a conflict for number input
      fontSize: '12px',
      lineHeight: 'normal',
      fontWeight: '500',
      color: 'presets.turquoise.100',
      // boxShadow: 'none',
      border: '1px solid',
      borderColor: 'presets.neutral.30',
      borderRadius: '6px',
      backgroundColor: 'presets.neutral.0',
      // outline: 'none',
      boxSizing: 'border-box',
      _dark: {
        backgroundColor: 'presets.dark.surface',
        borderColor: 'presets.neutral.90',
        color: 'presets.neutral.0',
        _disabled: {
          color: 'presets.neutral.60',
          backgroundColor: 'presets.dark.surfacePanel',
          opacity: 0.8,
          cursor: 'not-allowed',
        },
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'presets.neutral.10',
      },
      _placeholder: {
        color: 'presets.neutral.60',
        _dark: {
          color: 'presets.neutral.0',
        },
      },
      _focus: {
        borderColor: 'presets.turquoise.70 !important',
        boxShadow: 'none',
        _dark: {
          borderColor: 'presets.turquoise.50 !important',
          color: 'presets.neutral.0',
          backgroundColor: 'presets.dark.surface',
        },
      },
      _hover: {
        borderColor: 'presets.turquoise.50',
      },
    },
  },
  variants: {
    outline: {
      field: {
        border: '1px solid',
        borderColor: 'presets.neutral.30',
        _focus: {
          borderColor: 'presets.turquoise.70 !important',
          boxShadow: 'none',
        },
        _hover: {
          borderColor: 'presets.turquoise.50',
        },
      },
    },
    search: {
      field: {
        _dark: {
          backgroundColor: 'rgba(255, 255, 255, 0.09)',
          padding: '12px 10px 12px 45px',
          fontSize: '16px',
          fontWeight: '500',
          borderRadius: '41px',
          border: '1px solid white',
          color: 'rgba(255, 255, 255, 0.3)',
          _placeholder: {
            color: 'rgba(255, 255, 255, 0.3)',
          },
          _hover: {
            color: 'presets.neutral.0',
            _placeholder: {
              color: 'presets.neutral.0',
            },
          },
          _focusVisible: {
            borderWidth: '1px',
            borderColor: 'presets.turquoise.30',
            color: 'presets.neutral.0',
          },
        },
      },
    },
  },
  defaultProps: {
    variant: 'outline',
  },
})
